export default __webpack_public_path__ + "static/logo1-601a20ceb5d2b50a4ec7a9527a78bd8e.svg";